import React, { useState, useEffect, useContext } from 'react';


import SimpleTable from '../../components/tables/simpleTable';
import { ImportOutlined } from '@ant-design/icons';
import TrashModal from '../../components/modals/trashModal';
import RecoverModal from '../../components/modals/recoverModal';
import AddModal from '../../components/modals/addModal';
import EditModal from '../../components/modals/editModal';
import DeleteModal from '../../components/modals/deleteModal';
import { FaFileExcel } from "react-icons/fa";
import SearchFilter from '../../components/filters/search';
import CustomButton from '../../components/buttons/customButton';
import IsActiveFilter from '../../components/filters/isActive';
import AddButton from '../../components/buttons/addButton';
import DataFilter from '../../components/filters/dataFilter';
import DatePicker from '../../components/filters/datePicker';
import DropDownFilter from '../../components/filters/dropDownFilter';

import { FaPlus } from "react-icons/fa";

import Loader from '../../components/loader/loader';
import { numberFormatter, totalFormatter } from '../../components/formatters/numberFormatter';
import { dateFormatter } from '../../dynamic/dateFormatter';
import toast from 'react-hot-toast';

import { Space, Input, Tag, Button, Tabs, Upload } from 'antd';


import Select from 'react-select';
import { selectStyles } from '../../components/dropDown/selectStyle';
import AsyncSelect from 'react-select/async';

import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcViewDetails, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiBarcodeReader } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { FiRotateCcw, FiPrinter } from "react-icons/fi";

import { DataContext } from '../../init/getData';

import CompoundProduct from './forms/compound';
import SimpleProduct from './forms/simple';
import SerializedProduct from './forms/serialized';
import ProductionProduct from './forms/production';

import SimpleForm from './simple/simpleForm';
import ServiceForm from './service/serviceForm';
import { isActiveFormatter, isActiveTextFormatter } from '../../components/formatters/defFormatter';


function Product(props) {

  let { } = props;


  const { userData, settingData, api, categoryOptions, companyId, seasonData, refData } = useContext(DataContext);
  const userRole = userData.role;

  const [data, setData] = useState([]);
  const createdBy = parseInt(userData.id);



  //Get Data 
  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const dataArray = ['category']
        await refData(dataArray, companyId);
        setIsLoading(false);
      } catch (error) {
        console.error('Error refreshing data Contact Support');
      }
    };
    fetchData();
  }, []);


  const today = new Date().toISOString().split('T')[0];

  const [idRow, setIdRow] = useState([]);
  const [refTable, setRefTable] = useState(true);
  const [filter, setFilter] = useState({ search: '', categoryId: null, type: null });

  const [showAddSimple, setShowAddSimple] = useState(false);
  const [showAddCompound, setShowAddCompound] = useState(false);
  const [showAddSerialized, setShowAddSerialized] = useState(false);
  const [showAddProduction, setShowAddProduction] = useState(false);
  const [showAddService, setShowAddService] = useState(false);

  const [showEditSimple, setShowEditSimple] = useState(false);
  const [showEditCompound, setShowEditCompound] = useState(false);
  const [showEditProduction, setShowEditProduction] = useState(false);
  const [showEditSerialized, setShowEditSerialized] = useState(false);

  const [showTrashModal, setShowTrashModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showRecoverModal, setShowRecoverModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  const [productUnits, setProductUnits] = useState([]);
  const [productCompounds, setProductCompounds] = useState([]);
  const [category, setCategory] = useState([]);
  const [type, setType] = useState('');
  const [simpleProduct, setSimpleProduct] = useState({});
  const [compoundProduct, setCompoundProduct] = useState({});
  const [importedData, setImportedData] = useState([]);

  const [isLoading, setIsLoading] = useState(false);



  const table = 'product';
  const title = 'Products';



  const addModal = (type) => {
    if (type == 'simple') {
      setShowAddSimple(!showAddSimple);
    } else
      if (type == 'compound') {
        setShowAddCompound(!showAddCompound);
      } else
        if (type == 'serialized') {
          setShowAddSerialized(!showAddSerialized);
        } else
          if (type == 'production') {
            setShowAddProduction(!showAddProduction);
          } else
            if (type == 'service') {
              setShowAddService(!showAddService);
            }
    setIdRow(null);
    setType(type);
  }

  const editModal = (type, record) => {

    if (type == 'simple') {
      setShowAddSimple(!showAddSimple);
      if (!showAddSimple) {
        setIdRow(record);
      }
    }

    else if (type == 'compound') {
      setShowEditCompound(!showEditCompound);
      if (!showEditCompound) {
        setIdRow(record);
      }
    }

    else if (type == 'serialized') {
      setShowAddSerialized(!showAddSerialized);
      if (!showAddSerialized) {
        setIdRow(record);
      }
    }

    else if (type == 'production') {
      setShowEditProduction(!showEditProduction);
      if (!showEditProduction) {
        setIdRow(record);
      }
    }

    else if (type == 'service') {
      setShowAddService(!showAddService);
      if (!showAddService) {
        setIdRow(record);
      }
    }
  }





  const refreshTable = () => {
    setRefTable(!refTable)
  }

  const recoverModal = (e) => {
    if (!showRecoverModal) {
      setIdRow(e);
    }
    setShowRecoverModal(!showRecoverModal);
  }

  const trashModal = (e) => {
    if (!showTrashModal) {
      setIdRow(e);
    }
    setShowTrashModal(!showTrashModal);
  }

  const deleteModal = (e) => {
    if (!showDeleteModal) {
      setIdRow(e);
    }
    setShowDeleteModal(!showDeleteModal);
  }


  //Excel Data
  const getExcelData = (data) => {

    const transformedData = [];
    data.forEach(item => {

      const newItem = {
        id: item.id,
        barcode: item.barcode,
        category: item.category?.name,
        name: item.name,
        unit: item.unit,
        quantity: item.quantity,
        currency: item.currency?.code,
        cost: numberFormatter(item.cost),
        price: numberFormatter(item.price),
        status: isActiveTextFormatter(item.isActive),
        type: item.type,

      };

      transformedData.push(newItem);
    });

    return { transformedData };
  };


  const columnDefs = [
    { title: 'id', dataIndex: 'id', width: '5%', sorter: (a, b) => a.age - b.age },
    { title: 'barcode', dataIndex: 'barcode' },
    { title: 'category', dataIndex: 'category', render: (e) => (e?.name) },
    { title: 'name', dataIndex: 'name' },
    { title: 'unit', dataIndex: 'unit', width: '5%' },
    { title: 'quantity', dataIndex: 'quantity', width: '7%' },
    { title: 'currency', dataIndex: 'currency', width: '7%', render: (e) => (e?.code) },
    { title: 'cost', dataIndex: 'cost', width: '7%', render: numberFormatter },
    { title: 'price', dataIndex: 'price', width: '7%', render: numberFormatter },
    { title: 'Status', dataIndex: 'isActive', render: isActiveFormatter, width: '7%' },
    { title: 'type', dataIndex: 'type', width: '7%' },
    {
      title: 'Edt',
      width: '5%',
      render: (_, record) => (
        <FiEdit size={16} style={{ cursor: 'pointer', color: '#2E70A5' }} onClick={() => editModal(record.type, record)} />
      ),
    },
    {
      title: 'Trash',
      width: '5%',
      render: (_, record) => (record.isActive ? (
        <BiSolidTrash size={18} style={{ cursor: 'pointer', color: '#e6434f' }} onClick={() => trashModal(record)} />
      ) : <FcUndo size={18} style={{ cursor: 'pointer', color: '#e6434f' }} onClick={() => recoverModal(record)} />
      )
    }
  ];


  const refreshTableFunction = () => {
    setRefTable(!refTable)
  }


  const tableFooter = (
    <></>
  );


  // handle select change
  const handleSelectChange = (selectedOption, name) => {
    setFilter((prev) => ({
      ...prev,
      [name]: selectedOption?.value,
    }));
  };




  return (
    <div>

      {isLoading &&
        <Loader />
      }

      <div>

        <Row className='g-1 mb-3'>

          <Col md={2}>
            <SearchFilter setFilter={setFilter} />
          </Col>

          <Col md={2}>
            <Select
              styles={selectStyles}
              options={categoryOptions}
              isSearchable={true}
              isClearable={true}
              onChange={(e) => handleSelectChange(e, 'categoryId')} 
              value={categoryOptions?.find(option => option.value === filter.categoryId) || []}
              placeholder={'Select Category ... '}
              required
            />
          </Col>
   
          <Col md={6}>
          </Col>

          <Col md={2} className="d-flex justify-content-end">
            <Button onClick={refreshTableFunction}>
              <FiPrinter size={18} />
            </Button>
            <Button onClick={refreshTableFunction}>
              <FiRotateCcw size={18} />
            </Button>

            <div className='dropDown-btn'>
              <DropdownButton title="Add" size="sm" variant="success" className="custom-dropdown-button">
                {(<Dropdown.Item onClick={() => addModal('simple')}>Simple</Dropdown.Item>)}
                {settingData.serializedProduct && (<Dropdown.Item onClick={() => addModal('serialized')}>Serialized</Dropdown.Item>)}
                {settingData.variableProduct && (<Dropdown.Item onClick={() => addModal('variable')}>Variable</Dropdown.Item>)}
                {settingData.compoundProduct && (<Dropdown.Item onClick={() => addModal('compound')}>Compound</Dropdown.Item>)}
                {settingData.productionProduct && (<Dropdown.Item onClick={() => addModal('production')}>Production</Dropdown.Item>)}
                {settingData.serviceProduct && (<Dropdown.Item onClick={() => addModal('service')}>Service</Dropdown.Item>)}
              </DropdownButton>
            </div>
          </Col>

        </Row>


        <SimpleForm
          idRow={idRow}
          showModal={showAddSimple}
          toggleModal={() => addModal('simple')}
          refreshTable={refreshTable}
          type={'simple'}
        />


        <SimpleForm
          idRow={idRow}
          showModal={showAddSerialized}
          toggleModal={() => addModal('serialized')}
          refreshTable={refreshTable}
          type={'serialized'}
        />

        <SimpleForm
          idRow={idRow}
          showModal={showAddCompound}
          toggleModal={() => addModal('compound')}
          refreshTable={refreshTable}
          type={'compound'}
        />


        <ServiceForm
          idRow={idRow}
          showModal={showAddService}
          toggleModal={() => addModal('service')}
          refreshTable={refreshTable}
          type={'service'}
        />



        <div className="action-icons">


        </div>

      </div>


      {
        !isLoading &&


        <SimpleTable
          filter={filter}
          addModal={addModal}
          table={table}
          title={title}
          columnDefs={columnDefs}
          idRow={idRow}
          setIdRow={setIdRow}
          refreshTable={refTable}
          data={data}
          setData={setData}
          tableFooter={tableFooter}
          api={api}
          getExcelData={getExcelData}

        />
      }

      <TrashModal
        showModal={showTrashModal}
        toggleModal={trashModal}
        idRow={idRow}
        table={table}
        title={title}
        refreshTable={refreshTable}
        api={api}
        data={{ id: idRow?.id }}
      />

      <RecoverModal
        showModal={showRecoverModal}
        toggleModal={recoverModal}
        idRow={idRow}
        table={table}
        title={title}
        refreshTable={refreshTable}
        api={api}
        data={{ id: idRow?.id }}
      />


    </div >

  )
}

export default Product;
